import React, { createElement, useEffect, useCallback, forwardRef } from 'react';
import { Select } from '@alifd/next';
import request from '@/utils/request';
export const ApiMap = {
    'ENTITY_LIST': '/api/exchange/entity/summary',
    'RULE_ENGINE_LIST': '/api/decision/config/summary',
    'RULE_CAT_LIST': '/api/account/ruleCategory/summary',
    'ITEM_GRROUP_LIST': '/api/account/itemGroup/summary',
    'ACCT_STAND_RULE_LIST': '/api/account/standard/summary',
    'ACCT_PARAM_LIST': '/api/account/param/summary',
    'ACCT_SERVICE_LIST': '/api/account/service/summary',
    'ACCT_RULE_LIST': '/api/account/rule/summary',
    'ACCT_EVENT_LIST': '/api/account/event/summary',
    'BIZ_EVENT_LIST': '/api/account/businessEvent/summary',
    'ABSTRACT_LIST': '/api/account/abstracts/summary',
    'SBJECT_LIST': '/api/account/subject/summary',
    'ACCT_PARAM_ID_LIST': '/api/account/param/summary',
    'ACCT_PARAM_ID_ABSTRACT_LIST': '/api/account/param/summary',
    'ACCT_PARAM_ID_ITEM_LIST': '/api/account/param/summary',
    'ACCT_EVENT_ID_LIST': '/api/account/event/summary',
    'ABSTRACT_ID_LIST': '/api/account/abstracts/summary',
    'SBJECT_ID_LIST': '/api/account/subject/summary',
    'ACCT_STAND_RULE_ID_LIST': '/api/account/standard/summary',
    'ITEM_GRROUP_ID_LIST': '/api/account/itemGroup/summary',
    'ACCT_RULE_ID_LIST': '/api/account/rule/summary',
    'DECISION_MAP_LIST': '/api/decision/config/summary/us'
};
export const idList = ['ACCT_SERVICE_LIST', 'ACCT_PARAM_ID_LIST', 'ACCT_EVENT_ID_LIST', 'ABSTRACT_ID_LIST', 'SBJECT_ID_LIST', 'ACCT_STAND_RULE_ID_LIST', 'ITEM_GRROUP_ID_LIST', 'ACCT_RULE_ID_LIST', 'ACCT_PARAM_ID_ABSTRACT_LIST', 'ACCT_PARAM_ID_ITEM_LIST'];
export const noIdList = ['ENTITY_LIST', 'RULE_ENGINE_LIST', 'RULE_CAT_LIST', 'ITEM_GRROUP_LIST', 'ACCT_STAND_RULE_LIST', 'ACCT_PARAM_LIST', 'ACCT_RULE_LIST', 'ACCT_EVENT_LIST', 'BIZ_EVENT_LIST', 'ABSTRACT_LIST', 'SBJECT_LIST', 'DECISION_MAP_LIST'];
const AccountingEventList = ({ value, type, onChange, field, ...restProps }, ref) => {
    const [dataSource, setDataSource] = React.useState([]);
    const queryList = useCallback(async () => {
        const apiName = ApiMap[type];
        const setDatas = (content) => {
            const isidList = idList.includes(type);
            const data = content?.map(({ name, code, id }) => {
                return {
                    label: `${name}(${code})`,
                    value: isidList ? id : code,
                };
            });
            setDataSource(data);
        };
        if (type === 'DECISION_MAP_LIST') {
            const { content = [] } = await request.get(apiName, {
                params: { usageScenario: '902900000003' },
            });
            setDatas(content);
        }
        else if (type === 'ACCT_PARAM_ID_ITEM_LIST' || type === 'ACCT_PARAM_ID_ABSTRACT_LIST') {
            const paramCatType = type === 'ACCT_PARAM_ID_ITEM_LIST' ? 'item' : 'abstract';
            const { content = [] } = await request.get(apiName, {
                params: { paramCatType },
            });
            setDatas(content);
        }
        else {
            const { content = [] } = await request.get(apiName);
            setDatas(content);
        }
    }, [type]);
    useEffect(() => {
        queryList();
    }, [queryList]);
    const renderPreview = () => {
        const val = dataSource.find((item) => item.value === value)?.label;
        return createElement("span", null, val);
    };
    return (createElement(Select, { ...restProps, value: value, showSearch: true, hasClear: true, ref: ref, dataSource: dataSource, renderPreview: renderPreview, onChange: onChange }));
};
export const AccountingEventListRef = forwardRef(AccountingEventList);
export default AccountingEventListRef;
